import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import HomePage from "./pages/HomePage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import ResetPassword from "./pages/ResetPassword";
import BookingSuccessPage from "./pages/BookingSuccessPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import CleaningDashboard from "./pages/CleaningDashboard";
import CleaningViewAs from "./pages/CleaningViewAs";
import "./App.css";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/booking-success" element={<BookingSuccessPage />} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} />
            <Route path="/payment/cancel" element={<HomePage />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard/*" element={<AdminDashboard />} />
            <Route path="/admin/cleaning" element={<CleaningDashboard />} />
            <Route path="/admin/booking/cleaning" element={<CleaningViewAs />} />
            <Route path="/reset-password" element={<ResetPassword />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors closeButton />
      </div>
    </HelmetProvider>
  );
}

export default App;
